import { SafetyCertificateOutlined } from '@ant-design/icons';
import { Space, Tag, Typography } from 'antd';

export default function ActivationHeader() {
  return (
    <div className="activation-hash-page__header">
      <Space direction="vertical" size={4}>
        <Tag color="blue" icon={<SafetyCertificateOutlined />}>
          Link de ativação
        </Tag>

        <Typography.Title className="activation-hash-page__title" level={3}>
          Ativação da oficina
        </Typography.Title>

        <Typography.Paragraph
          className="activation-hash-page__description"
          type="secondary"
        >
          Crie o acesso do usuário responsável para concluir o cadastro inicial.
        </Typography.Paragraph>
      </Space>
    </div>
  );
}
